import { render, staticRenderFns } from "./deleteProductSpec.vue?vue&type=template&id=93aae8f4&scoped=true"
import script from "./deleteProductSpec.vue?vue&type=script&lang=js"
export * from "./deleteProductSpec.vue?vue&type=script&lang=js"
import style0 from "./deleteProductSpec.vue?vue&type=style&index=0&id=93aae8f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93aae8f4",
  null
  
)

export default component.exports